export default __webpack_public_path__ + "static/media/IMG_7746.825daf3f.webp";